module.exports = __webpack_public_path__ + "img/Cake-to-Age-Hold-Still,-Lion-600.829ee2bf.png";